<template>
  <div class="select-picker">
    <van-popup
      closeable
      close-icon-position="top-left"
      v-model="visible"
      position="bottom"
      :style="{ height: 'calc(80vh)' }"
    >
      <div class="pop-title">选择订单</div>
      <div class="search-area">
        <van-search
          v-model="keyword"
          placeholder="请输入搜索关键词"
          @search="onSearch"
        />
      </div>
      <div class="select-box">
        <data-list
          :api="getList"
          :params="searchParams"
          style="height: calc(80vh - 100px); overflow: hidden;overflow-y: auto;"
        >
          <template v-slot:item="item">
            <van-cell
              center
              :title="
                `${item.OrderNo}/${item.RoomNo || ''}/${item.GuestName || ''}`
              "
              :value="item.OrderStatusName"
              :label="
                `${moment(item.CheckInDate).format('YYYY-MM-DD')}至${moment(
                  item.CheckInDate,
                ).format('YYYY-MM-DD')}`
              "
              @click="handleSelect(item)"
            />
          </template>
        </data-list>
      </div>
    </van-popup>
  </div>
</template>

<script>
import orderApi from "@/api/order.js";
import DataList from "@/components/DataList";
import moment from "moment";
import { Popup, Picker, Cell, CellGroup, Icon, Search, Button } from "vant";
export default {
  name: "SelectMultiplePicker",
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Search.name]: Search,
    [Button.name]: Button,
    DataList,
  },
  props: {
    change: { type: Function },
    clear: { type: Function },
    params: {
      type: Object,
      default: () => {},
    },
    submit: Function,
  },
  data() {
    return {
      moment,
      getList: orderApi.QueryRoomInfoPage,
      visible: false,
      keyword: "",
      checkedValue: [],
      checkedData: [],
      searchParams: {},
    };
  },
  watch: {
    params(val) {
      this.searchParams = val;
    },
  },
  created() {
    this.searchParams = this.params;
  },
  mounted() {
    this.visible = true;
  },

  methods: {
    cancel() {
      this.visible = false;
      this.$emit("destroy");
    },
    onSearch() {
      this.searchParams = {
        ...this.searchParams,
        RoomNo: this.keyword,
      };
    },
    handleSelect(item) {
      this.$emit("submit", item);
      this.visible = false;
      this.$emit("destroy");
    },
  },
};
</script>

<style lang="less" scoped>
.select-box {
  position: relative;
  height: calc(80vh - 100px);
  .search-box {
    position: absolute;
    top: 40px;
    width: 100%;
    // position: ab;
  }
  .clear-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }
}
.pop-title {
  height: 40px;
  background: #ececec;
  padding: 5px 10px;
  text-align: center;
  line-height: 32px;
}
/deep/.van-popup__close-icon {
  top: 12px;
}
</style>
